import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import { Theme, createStyles, makeStyles, Badge } from "@material-ui/core";
import * as MUI from '@material-ui/core';
import type { ComponentType } from "react";

import ExportIcon from '../../../../../icons/Export';
import XLSIcon from '../../../../../icons/office/XLS';
import PPTIcon from '../../../../../icons/office/PPT';
import PPTADDIcon from '../../../../../icons/office/PPT_ADD';
import PPTREMOVEIcon from '../../../../../icons/office/PPT_REMOVE';
import PPTDOWNLOADIcon from '../../../../../icons/office/PPT_DOWNLOAD';
import { IReportExportQuery, useExport } from '../../../shared';
import { reportExportService } from '../../../dataFlow';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      boxSizing: 'content-box'
    },
    li: {
      overflow: 'visible'
    },
    icon: {
      paddingRight: theme.spacing(1)
    }
  })
);

export const Export: React.FC<{ loading?: boolean }> = ({ loading }) => {
  const [query, setQuery] = React.useState<unknown | null>(null);
  const storeJSON = sessionStorage.getItem("export_ppt_queries");
  const storeQueries: IReportExportQuery[] = storeJSON != null ? JSON.parse(storeJSON) : [];
  const storeHasCurrent = Boolean(storeQueries.find(x => JSON.stringify(x) === JSON.stringify(query)));

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [disabled, setDisabled] = React.useState(false);

  const exportBuilder = useExport();

  const handleClick = event => {
    const success = () => {
      setDisabled(false);
      setQuery(exportBuilder.buildQuery());
    };
    const fail = () => {
      setDisabled(true);
      let checkInterval;
      checkInterval = setInterval(() => {
        const repeatErrors = exportBuilder.validate();
        if (repeatErrors.length === 0) {
          success();
          clearInterval(checkInterval);
        }
      }, 1000);
    };

    const errors = exportBuilder.validate();
    errors.length === 0 ? success() : fail();
    setAnchorEl(event.currentTarget);
  };

  const handle = (call?: ((q: IReportExportQuery[]) => Promise<void>)) => () => {
    setAnchorEl(null);
    if (call && !disabled) call([query as any]);
  };

  const classes = useStyles();
  const classNameButton = classes.button;
  if (loading) {
    return <Skeleton variant="circle" width={48} height={48} />
  }

  const addSlidePPT = () => {
    storeQueries.push(query as any);
    sessionStorage.setItem("export_ppt_queries", JSON.stringify(storeQueries));
  }

  const removeSlidePPT = () => {
    const storeJSON = sessionStorage.getItem("export_ppt_queries");
    let store: IReportExportQuery[] = storeJSON != null ? JSON.parse(storeJSON) : [];
    store = store.filter(x => JSON.stringify(x) !== JSON.stringify(query));
    sessionStorage.setItem("export_ppt_queries", JSON.stringify(store));
  }

  const downloadPPT = () => {
    if (storeQueries.length === 0) {
      storeQueries.push(query as any);
    }
    sessionStorage.removeItem("export_ppt_queries");
    reportExportService.pptx(storeQueries);
  }

  const buttons = [
    [XLSIcon, 'Export to XLSX', reportExportService.xlsx, disabled],
    [PPTADDIcon, 'Add slide to PPTX', addSlidePPT, storeHasCurrent || disabled],
    [PPTREMOVEIcon, 'Remove slide from PPTX', removeSlidePPT, !storeHasCurrent || disabled],
    [PPTDOWNLOADIcon, storeQueries.length ? (<Badge badgeContent={storeQueries.length} color="primary">Download PPTX export</Badge>) : 'Download PPTX export', downloadPPT, disabled],
    // [PDFIcon, 'PDF'],
  ] as [ComponentType<{className: string}>, string, (q: IReportExportQuery[]) => Promise<void>, boolean][];

  return (<>
    <MUI.IconButton className={classNameButton} aria-label="Export" onClick={handleClick}>
      <ExportIcon width='14px' height='14px' />
    </MUI.IconButton>
    <MUI.Menu
      id="simple-menu"
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handle()}
    >
      {buttons.map(([Icon, label, call, disabledBtn]) => (
        <MUI.MenuItem
          key={label as string}
          onClick={handle(call)}
          className={classes.li}
          disabled={disabledBtn}
        >
          <Icon className={classes.icon} />
          {label}
        </MUI.MenuItem>
      ))}
    </MUI.Menu>
  </>);
} 